<template>
  <div>
    <h1>Add/Edit Oscar Categories</h1>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label>Category Name</label>
        <input class="form-control" type="text" v-model="category.name" required />
      </div>
      <div class="form-group">
        <label>Active</label>
        <select class="form-control" v-model="category.active">
          <option value="true">True</option>
          <option value="false">False</option>
        </select>
      </div>
      <button class="btn btn-warning btn-block">{{ editMode }} Category</button>
       <p class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</p>
    </form>
    <hr />
    <h2>Categories</h2>
    <ul class="list-group categories-list">
    <draggable v-model="categoriesSorted">
      <transition-group>
        <li v-for="category in categoriesSorted" :key="category.name"
        class="list-group-item"
        @click="editCategory(category)">{{ category.name }}<button type="button" class="close" aria-label="Close" @click.stop="deleteCategory(category)"><span aria-hidden="true">&times;</span></button></li>
      </transition-group>
    </draggable>
    </ul>
  </div>
</template>

<script>
import { db } from '../../firebase/';
import draggable from 'vuedraggable';

export default {
  name: 'Categories',
  data() {
    return {
      category: this.initialCategory(),
      errorMessage: null,
      categories: {},
      editMode: 'Add'
    };
  },
  firebase: {
    categories: {
      source: db.ref('categories')
    }
  },
  methods: {
    initialCategory() {
      return {
        name: '',
        order: null,
        active: true
      };
    },
    editCategory(category) {
      this.category = category;
      this.editMode = 'Update';
    },
    addCategory() {
      this.category.order = this.categories.length;

      db.ref('categories').push({
        name: this.category.name,
        order: this.category.order,
        active: this.category.active
      });

      this.category = this.initialCategory();
    },
    updateCategory() {
      this.$firebaseRefs.categories.child(this.category['.key']).child('name').set(this.category.name);
      this.category = this.initialCategory();
      this.editMode = 'Add';
    },
    deleteCategory(category) {
      if (this.editMode === 'Update' && this.category['.key'] === category['.key']) {
        this.category = this.initialCategory();
        this.editMode = 'Add';
      }

      this.$firebaseRefs.categories.child(category['.key']).remove();
    },
    submitForm() {
      if (this.editMode === 'Add') {
        this.addCategory();
      } else {
        this.updateCategory();
      }
    }
  },
  computed: {
    categoriesSorted: {
      get() {
        let sorted = [...this.categories].sort((one, two) => { return one.order - two.order; });

        return sorted;
      },
      set(value) {
        let updates = {};

        value.forEach((item, index) => {
          db.ref('categories').on('value', function(snapshot) {
            updates[item['.key'] + '/order'] = index;
          });
        });

        db.ref('categories').update(updates);
      }
    }
  },
  components: {
    draggable
  }
};
</script>

<style lang="scss" scoped>
  .categories-list {
    margin: 0 0 50px;
    li {
      cursor: pointer;
    }
    li:hover {
      background: #eee;
    }
  }

  hr {
    margin: 35px 0 25px;
  }
</style>
